<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="900"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :model="detailData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <!-- Overlap Session Details Header -->
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Overlap Sessions Details</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_full_name" label="User Full Name:">
              <el-input v-model="detailData.user_full_name" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_email" label="User Email:">
              <el-input v-model="detailData.user_email" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="form_kind" label="Form Kind:">
              <el-input v-model="detailData.form_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="action_kind" label="Action Kind:">
              <el-input v-model="detailData.action_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="document_id" label="Document ID:">
              <el-input v-model="detailData.document_id" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="log_date" label="Log Date:">
              <el-input :value="formatDateTime(detailData.log_date)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="created_at" label="Created At:">
              <el-input :value="formatDateTime(detailData.created_at)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="updated_at" label="Updated At:">
              <el-input :value="formatDateTime(detailData.updated_at)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="label-style" prop="comment" label="Comment:">
              <el-input v-model="detailData.comment" type="textarea" :rows="2" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- AWS Batch Job Section (before_change) -->
        <el-alert type="warning" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">AWS Batch Job Submitted</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="jobId" label="Job ID:">
              <el-input v-model="beforeChangeData.jobId" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="jobName" label="Job Name:">
              <el-input v-model="beforeChangeData.jobName" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Result Section (result_display) -->
        <el-alert type="success" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Result</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="status" label="Status:">
              <el-tag :type="getStatusTagType(resultDisplayData.status)">
                {{ resultDisplayData.status || "—" }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="label-style" prop="message" label="Message:">
              <el-input
                v-model="resultDisplayData.message"
                type="textarea"
                :rows="2"
                readonly
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i>
          <span class="moderat-btn-apply">Close</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      detailData: {
        id: 0,
        log_date: "",
        form_kind: "",
        action_kind: "",
        document_id: "",
        comment: "",
        user_id: 0,
        user_full_name: "",
        user_email: "",
        result_display: "",
        created_at: "",
        updated_at: "",
        before_change: "",
      },
      beforeChangeData: {
        jobId: "",
        jobName: "",
      },
      resultDisplayData: {
        status: "",
        message: "",
      },
    };
  },
  watch: {
    open_modal: function (newVal) {
      this.show = newVal;
      if (newVal === true) {
        this.parseModalData();
      }
    },
  },
  methods: {
    parseModalData() {
      if (this.data_modal) {
        const data =
          typeof this.data_modal === "string"
            ? JSON.parse(this.data_modal)
            : this.data_modal;

        this.detailData = { ...data };

        if (data.before_change) {
          try {
            this.beforeChangeData =
              typeof data.before_change === "string"
                ? JSON.parse(data.before_change)
                : data.before_change;
          } catch (e) {
            console.error("Error parsing before_change:", e);
            this.beforeChangeData = { jobId: "", jobName: "" };
          }
        }

        if (data.result_display) {
          try {
            this.resultDisplayData =
              typeof data.result_display === "string"
                ? JSON.parse(data.result_display)
                : data.result_display;
          } catch (e) {
            console.error("Error parsing result_display:", e);
            this.resultDisplayData = { status: "", message: "" };
          }
        }
      }
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        return date.toLocaleString("en-AU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      } catch (e) {
        return dateStr;
      }
    },
    getStatusTagType(status) {
      if (!status) return "info";
      const s = String(status).toUpperCase();
      if (s === "SUCCEEDED") return "success";
      if (s === "FAILED" || s === "ERROR") return "danger";
      if (s === "RUNNING" || s === "SUBMITTED") return "warning";
      return "info";
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 30px 10px;
}

.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}

.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.mt-3 {
  margin-top: 12px;
}

.alert-style {
  margin-bottom: 10px;
}
</style>
